import styles from '@styles/SingleBoat/detail_table.module.scss';
import { Checkbox, Collapse, Table } from 'antd';
import { useState, FC } from 'react';

type Props = {
  title: string;
  link: string;
  menu: {
    title: string;
    link: string;
    subMenu: {
      key: string | JSX.Element;
      value: string | number | boolean | JSX.Element;
      hasValue: boolean;
    }[];
  }[];
};

const DetailTable: FC<Props> = ({ title, link, menu }) => {
  const [checked, setChecked] = useState(true);
  const { Panel } = Collapse;
  const { Column } = Table;

  const defaultActiveKey = menu.map((item) => item.link);

  const toggleEmptyFields = (e: any) => setChecked(e.target.checked);

  return (
    <div className={styles.container} id={link}>
      <div className={styles.containerTitleWrap}>
        <h3 className={styles.containerTitle}>{title}</h3>
        <Checkbox defaultChecked onChange={toggleEmptyFields}>
          Hide empty fields
        </Checkbox>
      </div>

      <Collapse defaultActiveKey={defaultActiveKey} className={styles.containerCollapse} ghost>
        {menu.map((item) => {
          const { title: menuTitle, link: menuLink, subMenu } = item;

          return (
            <Panel
              key={item.link}
              header={<span className={styles.collapseTitle}>{menuTitle}</span>}
              id={menuLink}
              className={styles.collapseItem}
            >
              <Table
                dataSource={subMenu.filter((subMenuItem) => (checked ? subMenuItem.hasValue !== false : subMenuItem))}
                pagination={false}
                className={styles.itemTable}
              >
                <Column
                  title="Name"
                  dataIndex="name"
                  key="key"
                  render={(key, tableItem: any) => {
                    const { empty } = tableItem as {
                      key: string | JSX.Element;
                      empty: boolean | undefined;
                      value: string | number;
                    };

                    return {
                      props: {
                        className: empty ? styles.itemEmpty : '',
                      },
                      children: key,
                    };
                  }}
                />
                <Column
                  title="Value"
                  dataIndex="value"
                  key="value"
                  render={(value, tableItem: any) => {
                    const { empty } = tableItem as {
                      empty: boolean | undefined;
                    };

                    return {
                      children: value || (!empty ? '-' : ''),
                    };
                  }}
                />
              </Table>
            </Panel>
          );
        })}
      </Collapse>
    </div>
  );
};

export default DetailTable;
